module.exports = __webpack_public_path__ + "media/nom-landing/nom-steps-4-39c5c48c.png";